/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 엠베서더 지원자 조회
  async index(data?: any) {
    return camelize(
      await $axios.get(`/brand/ambassador`, snakelize({ params: data }))
    );
  },

  // 엠베서더 지원자 상태 변경
  async update(data?: any) {
    return camelize(
      await $axios.patch(
        `/brand/ambassador/${data.applicantId}`,
        snakelize(data)
      )
    );
  },

  // 엠베서더 규칙 조회
  async rules(data?: any) {
    return camelize(
      await $axios.get(`/brand/ambassador/rules`, snakelize({ params: data }))
    );
  },

  // 앰베서더 선정 요청
  async requestSelectionToAdmin(data?: any) {
    return camelize(await $axios.post(`/brand/ambassador/request-selection-to-admin`, snakelize(data)));
  }
})